import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Grid, Link } from "@mui/material";
import { DangerHexagon } from "@mynaui/icons-react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AssetCard from "./AssetCard";

const AssetsAtRisk = ({ assets }) => {
  const navigate = useNavigate();
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <DangerHexagon size={24} color="#020618" strokeWidth={1.5} />
          <Typography
            variant="h5"
            sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "28px", color: "#111827" }}
          >
            Assets at Risk
          </Typography>
        </Box>
        <Link
          component="button"
          underline="none"
          onClick={() => navigate("/assets")}
          sx={{
            display: "flex",
            alignItems: "center",
            color: "text.secondary",
            fontSize: "0.875rem",
            fontWeight: 500,
            cursor: "pointer",
            "&:hover": { color: "text.primary" },
          }}
        >
          View All
          <ChevronRightIcon sx={{ fontSize: 18 }} />
        </Link>
      </Box>

      <Grid container spacing={2.5}>
        {assets.map((asset) => (
          <Grid size={{ xs: 12, md: 6 }} key={asset.id}>
            <AssetCard asset={asset} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AssetsAtRisk;
